"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestAccessDto = void 0;
class RequestAccessDto {
    organizationID;
    firstName;
    lastName;
    email;
    message;
    link;
}
exports.RequestAccessDto = RequestAccessDto;
